import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const usePanelEditableStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: '100%',
      '& > div:nth-child(odd)': {
        backgroundColor: '#f2f2f2'
      }
    },
    group: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    list: {
      padding: 0,
      '& li': {
        padding: 0,
      },
      '& button:hover': {
        color: theme.palette.error.main
      }
    },
    headerWithActions: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      '& > div > span': {
        fontSize: '0.875rem',
        fontWeight: 600,
        lineHeight: '1.43'
      }
    }
  })
);